export enum PaymentStatus {
  UNKNOWN = 'UNKNOWN',
  PAID = 'PAID',
  NOT_PAID = 'NOT_PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PENDING = 'PENDING',
  OVERDUE = 'OVERDUE',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
} 